import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledTagLocalFormContainer = styled(Box)`
  &&& {
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-4);
  }
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 35%;
  gap: var(--cl-space-4);
`;
